// @flow
import { Card } from '@mui/material';
import React from 'react';
import Chart from 'react-apexcharts';

// simple bar chart
const BarChart = (props) => {
    // default options

    const apexBarChartOpts = {
        chart: {
            height: 380,
            type: 'bar',
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                dataLabels: {
                    position: 'top',
                },
            },
        },
        dataLabels: {
            enabled: true,
            offsetX: -6,
            style: {
                fontSize: '12px',
                colors: ['#fff'],
            },
        },
        colors: ['#fa5c7c', '#6c757d'],
        stroke: {
            show: true,
            width: 1,
            colors: ['#fff'],
        },

        xaxis: {
            categories: props.data?.labels || [],
        },

        states: {
            hover: {
                filter: 'none',
            },
        },
        grid: {
            borderColor: '#f1f3fa',
        },
        responsive: [
            {
                breakpoint: 600,
                options: {
                    chart: {
                        height: 350,
                        width: '100%',
                    },
                    legend: {
                        show: true,
                    },
                },
            },
        ],
    };

    // chart data
    const apexBarChartData = [
        {
            name: props.name || '',
            data: props.data?.data || [],
        },
    ];

    return <Chart options={apexBarChartOpts} series={apexBarChartData} type="bar" className="apex-chartss" />;
};

export default BarChart;
